<script setup lang="ts">
import { APP_URL } from './config'

// TODO: think about `vite-plugin-sass-dts` here
const primaryColor = '#28414c'

useHead({
  title: import.meta.env.VITE_APP_NAME || 'Jstaking validator',
  meta: [
    { name: 'description', content: import.meta.env.VITE_APP_DESCRIPTION },
    { name: 'keywords', content: import.meta.env.VITE_APP_KEYWORDS },
    {
      name: 'theme-color',
      content: () => '#ffffff',
    },
    {
      name: 'msapplication-TileColor',
      content: () => primaryColor,
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: () => `${APP_URL}/img/favicon.svg`,
    },
    {
      rel: 'mask-icon',
      href: () => `${APP_URL}/img/safari-pinned-tab.png`,
      color: primaryColor,
    },
  ],
})

const loaded = ref(0)
onMounted(() => {
  loaded.value = 1
})
</script>

<template>
  <router-view :style="{ opacity: loaded, transition: 'opacity .3s ease-in-out' }" />
</template>
